import { Box, Typography } from '@mui/material';
import BasePageContainer from 'components/views/RegisterValidationComp/PageSuccessAndErrors/BasePageContainer';

import { ReactComponent as IcAppleStore } from 'assets/icons/ic-apple-store.svg';
import { ReactComponent as IcGooglePlay } from 'assets/icons/ic-google-play.svg';
import { ReactComponent as IcIturinInstallationDone } from 'assets/icons/ic-iturin-installation-done.svg';

const InstallationDone = () => {
    return (
        <BasePageContainer>
            <Box>
                <Box paddingBottom='1rem' display='grid' justifyItems='center' marginTop='2.4rem'>
                    <Typography fontWeight={700} textTransform='uppercase' textAlign='center' sx={{
                        fontSize: { xs: '1.375rem', md: '1.875rem' },
                        'b': {
                            color: 'secondary.main'
                        }
                    }}>
                        INSTALAÇÃO JÁ <b>REALIZADA</b>!
                    </Typography>
                    <Box margin='-1rem 0 -4rem' sx={{
                        'svg': {
                            maxWidth: '100%',
                        }
                    }}>
                        <IcIturinInstallationDone />
                    </Box>
                    <Box>
                        <Typography margin='0 auto' sx={{
                            textAlign: { xs: 'left', md: 'center' },
                            fontSize: { xs: '1rem', md: '.9375rem' },
                            maxWidth: '25.5rem',
                            lineHeight: '1.2'
                        }}>
                            Nosso app já está disponível para <b>download</b>, instale e tenha acesso a muitos serviços como:
                        </Typography>
                        <Box component='ul' display='flex' justifyContent='space-between' sx={{
                            flexDirection: { xs: 'column', md: 'row' },
                            paddingTop: { xs: '1.5rem', md: '1.6rem' },
                            paddingLeft: { xs: '1rem', md: '0' },
                            rowGap: '.75rem',
                            'li': {
                                listStyleType: 'disc',
                                marginRight: '2.5rem',
                            }
                        }}>
                            {['Assistência 24h', 'Pagamento de boletos', 'Clube de vantagens exclusivo'].map((value, index) =>
                                <li key={index}>
                                    <Typography fontWeight='700' sx={{
                                        fontSize: { xs: '.875rem', md: '.9375rem' },
                                    }}>
                                        {value}
                                    </Typography>
                                </li>
                            )}
                        </Box>
                        <Box display='flex' gap='1.25rem' justifyContent='center' sx={{
                            paddingTop: { xs: '1.87rem', md: '1.5rem' },
                        }}>
                            <a href="https://apps.apple.com/br/app/ituran-digital/id1486608545" className='apple' target='blank'>
                                <IcAppleStore />
                            </a>
                            <a href="https://play.google.com/store/search?q=ituran&c=apps" className='android' target='blank' >
                                <IcGooglePlay />
                            </a>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </BasePageContainer>
    );
}

export default InstallationDone;